import type { ExamTypeConfig } from '@examflow/core';
import { registerExamQuestionTypes } from '@examflow/core';
import { TOPIK_SECTIONS } from './sections';
import { topikScoringRules } from './scoring';
import { TOPIK_QUESTION_TYPE_DEFINITIONS } from './questionTypes';

/**
 * TOPIK 考试完整配置
 */
export const topikExamConfig: ExamTypeConfig = {
  id: 'topik',
  name: 'TOPIK (Test of Proficiency in Korean)',
  description:
    '韩国语能力考试 - 韩国官方认证的韩语水平测试，分为 1-6 级（TOPIK I 1-2级，TOPIK II 3-6级）',
  languageId: 'korean',
  questionTypeDefinitions: TOPIK_QUESTION_TYPE_DEFINITIONS,
  sections: TOPIK_SECTIONS,
  scoringRules: topikScoringRules,
};

registerExamQuestionTypes('topik', Object.values(TOPIK_QUESTION_TYPE_DEFINITIONS));

export * from './types';
export * from './sections';
export * from './scoring';
export * from './levels';
export * from './intro';
export * from './questionTypes';
